import React from "react";
import { useCountryConfig } from "../lib/useCountryConfig";

/**
 * MaliStripe — preserved name for back-compat. Now data-driven: reads
 * the per-country `flag_stripes` array from /api/country-config so a
 * new country deployment ships its flag without touching this file.
 *
 * The default (Mali) renders the same green/yellow/red bar that has
 * been on every page since v1.
 */
export const MaliStripe = ({ className = "" }) => {
  const cfg = useCountryConfig();
  const stripes = (cfg?.flag_stripes && cfg.flag_stripes.length > 0)
    ? cfg.flag_stripes
    : [
        { name: "green",  color: "var(--mali-green)" },
        { name: "yellow", color: "var(--mali-yellow)" },
        { name: "red",    color: "var(--mali-red)" },
      ];

  return (
    <div
      className={`h-1.5 w-full flex ${className}`}
      data-testid="country-stripe"
      aria-hidden="true"
    >
      {stripes.map((s, idx) => (
        <span
          key={`${s.name || idx}-${idx}`}
          className="flex-1"
          style={{ backgroundColor: s.color }}
        />
      ))}
    </div>
  );
};

// New name — same component, country-agnostic. Both exports refer to
// the same implementation so older imports of `MaliStripe` keep working
// and new code can import `CountryStripe`.
export const CountryStripe = MaliStripe;

export default MaliStripe;
